import {
    Button,
    Icon,
    Icons,
    ThemeIconSizeVariable,
    useDisclosure,
} from "@caspeco/casper-ui-library";
import SideNavigation from "components/side-navigation/side-navigation";
import { useTranslation } from "react-i18next";

export function HamburgerButton({ isLeftAligned = true }: { isLeftAligned?: boolean }) {
    const { t } = useTranslation();
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            <SideNavigation
                onCloseSideNav={onClose}
                isSideNavOpen={isOpen}
                isLeftAligned={isLeftAligned}
            />
            <Button
                key={ThemeIconSizeVariable.Medium}
                aria-label={t("actionShowMore")}
                onClick={onOpen}
                size={["lg"]}
                w="40px"
                variant="secondary"
                data-track-click="hamburger-button"
            >
                <Icon icon={Icons.Menu} size={ThemeIconSizeVariable.Medium} />
            </Button>
        </>
    );
}
